import { postBatchQueryActivityTypeByCondition } from "../request/designapi/design/retailOrder/batchQueryActivityTypeByCondition/post.js";
import { createBatchRequestWithCache } from "./createBatchRequestWithCache.js";
const opPostBatchQueryActivityTypeByCondition = createBatchRequestWithCache(postBatchQueryActivityTypeByCondition, {
  debounceDelay: 50,
  apiName: "designapi/design/retailOrder/batchQueryActivityTypeByCondition\u63A5\u53E3"
});
export { opPostBatchQueryActivityTypeByCondition };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/utils/opPostBatchQueryActivityTypeByCondition.js